import { UrlObject } from "url";
import BreadcrumbLink from "components/elements/Breadcrumbs/BreadcrumbLink";
import { useRouteParamNumber } from "lib/hooks/useRouteParam";
import { useAssetVersion } from "lib/hooks/assets/useAssetVersion";
import { formatVersionLabel } from "lib/actions/util/formatVersionLabel";

function useCurrentAssetId(): number | null {
  const [id] = useRouteParamNumber("assetId");
  return id;
}

export default function BreadcrumbAssetVersion(p: {
  params: string[];
  href: UrlObject;
}) {
  const assetId = useCurrentAssetId();
  const assetVersionId = p.params[0] && +p.params[0];

  const { version, isLoading } = useAssetVersion(assetId, assetVersionId);

  if (isLoading || !version) {
    return <BreadcrumbLink href={null}>Loading...</BreadcrumbLink>;
  }

  return (
    <BreadcrumbLink href={p.href}>{formatVersionLabel(version)}</BreadcrumbLink>
  );
}
